import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  Typography,
  Paper
} from '@mui/material';
import { Home as HomeIcon } from '@mui/icons-material';

// Import illustration
import notFoundIllustration from '../assets/images/404-illustration.svg';

const NotFound = () => {
  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          textAlign: 'center',
          py: 8
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 6,
            borderRadius: 3,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%'
          }}
        >
          <Typography
            variant="h1"
            component="h1"
            color="primary"
            sx={{ fontWeight: 700, mb: 2 }}
          >
            404
          </Typography>
          
          <Typography variant="h4" gutterBottom>
            Page Not Found
          </Typography>
          
          <Box sx={{ my: 4, maxWidth: '100%', height: 'auto' }}>
            <img
              src={notFoundIllustration}
              alt="Page not found illustration"
              style={{ maxWidth: '100%', height: 'auto', maxHeight: '300px' }}
            />
          </Box>
          
          <Typography variant="body1" color="textSecondary" paragraph>
            Oops! The page you are looking for doesn't exist or has been moved.
          </Typography>
          
          <Button
            variant="contained"
            color="primary"
            size="large"
            component={RouterLink}
            to="/"
            startIcon={<HomeIcon />}
            sx={{ mt: 2 }}
          >
            Back to Home
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default NotFound;
